import React, { useState } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import image from "../assests/sitelogo.png";

export default function ViewProfile({ e }) {

  const[loader, setLoader]= useState(false);

  const exportToExcel = async () => {
    setLoader(true);
    try {
      // Create a new workbook and worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Add the image to the workbook
      const imageId = workbook.addImage({
        base64: image, // Use a base64-encoded image
        extension: "png", // Specify the file type
      });

      // Set the dimensions and position of the image
      worksheet.addImage(imageId, {
        tl: { col: 0.5, row: 0.5 }, // Top-left corner position
        ext: { width: 250, height: 100 }, // Image dimensions
      });
      worksheet.getCell("B6").value = '';
      worksheet.mergeCells("A1:F6");
      worksheet.getCell("B7").alignment = { vertical: "middle", horizontal: "left" };
      worksheet.getCell("B7").font = { bold: true };
      worksheet.getRow(7).height = 80;

      // Add introduction text
      worksheet.getCell("B7").value = `You are about to experience creativity and commitment at its best.`;
      worksheet.mergeCells("B7:H7");
      worksheet.getCell("B7").alignment = { vertical: "middle", horizontal: "left" };
      worksheet.getCell("B7").font = { bold: true };
      worksheet.getRow(7).height = 30;

      // Personalized message
      worksheet.getCell("B8").value = `Hi ${e.clientDetails.cname}, welcome to the Fabdiz family! Thank you for taking the time and having a discussion with me. We have taken into account all your requirements and created a quote for you. We believe it will perfectly suit your style and budget.`;
      worksheet.mergeCells("B8:H8");
      worksheet.getCell("B8").alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      worksheet.getCell("B8").font = { bold: true };
      worksheet.getRow(8).height = 70;

      // User details
      worksheet.getCell("O8").value = `${e.userDetials[0].designation}\n${e.userDetials[0].name}\n+91 ${e.userDetials[0].mobile}\n${e.userDetials[0].email}`;
      worksheet.mergeCells("O8:R8");
      worksheet.getCell("O8").alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      worksheet.getCell("O8").font = { bold: true };

      // Section header
      worksheet.getCell("A10").value = "ROOMS";
      worksheet.mergeCells("A10:Z10");
      worksheet.getCell("A10").alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      worksheet.getCell("A10").font = { bold: true };
      worksheet.getRow(10).height = 30;
      worksheet.getCell("A10").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "B6D7A8" }, // Light green
      };
      let currentRowIndex = 11;

      // Add quotation data
      e.quotationData.forEach((item, index) => {
       
        currentRowIndex+= 2

        // Add room type name
        worksheet.unMergeCells(`A${currentRowIndex-2}:Z${currentRowIndex-2}`);
        worksheet.getCell(`A${currentRowIndex-2}`).value = item.roomTypeName;
        worksheet.mergeCells(`A${currentRowIndex-2}:Z${currentRowIndex-2}`);
        worksheet.getCell(`A${currentRowIndex-2}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        worksheet.getCell(`A${currentRowIndex-2}`).font = { bold: true };
        worksheet.getRow(currentRowIndex-2).height = 20;
        worksheet.getCell(`A${currentRowIndex-2}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "91C2DE" }, // Light blue
        };

        worksheet.unMergeCells(`A${currentRowIndex-1}:Z${currentRowIndex-1}`);
        ["A", "C", "E", "G", "I", "K", "M", "O", "Q"].forEach((col, idx) => {
          const labels = [
            "Item/Description",
            "Finish",
            "Width(FT)",
            "Height(FT)",
            "Area(Sqft/RFT)",
            "Qty",
            "Price",
            "Amount",
            "Remark",
          ];

          const cell = worksheet.getCell(`${col}${currentRowIndex-1}`);
          cell.value = labels[idx];

          // Add background color (for example, light gray)
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'B5D6A7' }, // Light gray color
          };

          // Set text alignment
          cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        });

        worksheet.mergeCells(`A${currentRowIndex-1}:B${currentRowIndex-1}`);
        worksheet.mergeCells(`C${currentRowIndex-1}:D${currentRowIndex-1}`);
        worksheet.mergeCells(`E${currentRowIndex-1}:F${currentRowIndex-1}`);
        worksheet.mergeCells(`G${currentRowIndex-1}:H${currentRowIndex-1}`);
        worksheet.mergeCells(`I${currentRowIndex-1}:J${currentRowIndex-1}`);
        worksheet.mergeCells(`K${currentRowIndex-1}:L${currentRowIndex-1}`);
        worksheet.mergeCells(`M${currentRowIndex-1}:N${currentRowIndex-1}`);
        worksheet.mergeCells(`O${currentRowIndex-1}:P${currentRowIndex-1}`);
        worksheet.mergeCells(`Q${currentRowIndex-1}:Z${currentRowIndex-1}`);
        worksheet.getRow(currentRowIndex-1).height = 15;

  

        // Add items
        item.title.map((item2) => {

          if (item2.value2 > 0 && item2.name === "Wardrobe - Slider") {
            worksheet.unMergeCells(`A${currentRowIndex}:R${currentRowIndex}`);
            worksheet.getCell(`A${currentRowIndex}`).value = `${item2.name} ${item2.label2 ? `(${item2.label2})` : ""}`;
            worksheet.getCell(`E${currentRowIndex}`).value = item2.width || null;
            worksheet.getCell(`G${currentRowIndex}`).value = item2.height || null;
            worksheet.getCell(`I${currentRowIndex}`).value = item2.area || null;
            worksheet.getCell(`C${currentRowIndex}`).value = item2.label;
            worksheet.getCell(`K${currentRowIndex}`).value = item2.qnty || null;
            worksheet.getCell(`M${currentRowIndex}`).value = '';
            worksheet.getCell(`O${currentRowIndex}`).value =  item2.width !=='' ||item2.rft !=='' ||item2.qnty !=='' || item2.height !=='' || item2.area !==''  && item2.price > 0 ? item2.price : '';
            worksheet.getCell(`Q${currentRowIndex}`).value = item2.remark;

            worksheet.mergeCells(`A${currentRowIndex}:B${currentRowIndex}`);
            worksheet.mergeCells(`C${currentRowIndex}:D${currentRowIndex}`);
            worksheet.mergeCells(`E${currentRowIndex}:F${currentRowIndex}`);
            worksheet.mergeCells(`G${currentRowIndex}:H${currentRowIndex}`);
            worksheet.mergeCells(`I${currentRowIndex}:J${currentRowIndex}`);
            worksheet.mergeCells(`K${currentRowIndex}:L${currentRowIndex}`);
            worksheet.mergeCells(`M${currentRowIndex}:N${currentRowIndex}`);
            worksheet.mergeCells(`O${currentRowIndex}:P${currentRowIndex}`);
            worksheet.mergeCells(`Q${currentRowIndex}:Z${currentRowIndex}`);

            worksheet.getRow(currentRowIndex).height = 35;
            worksheet.getRow(currentRowIndex).eachCell((cell, colIndex) => {
              cell.alignment = { vertical: "middle", horizontal:'centerContinuous', wrapText: true };
            });
            worksheet.getCell(`Q${currentRowIndex}:Z${currentRowIndex}`).alignment = {
              vertical: "middle",
              horizontal: "left", // Set to "left" for this specific merged cell range
              wrapText: true,
            };
            worksheet.getCell(`A${currentRowIndex}:B${currentRowIndex}`).alignment = {
              vertical: "middle",
              horizontal: "left", // Set to "left" for this specific merged cell range
              wrapText: true,
            };
            currentRowIndex++;
          }
          else if (item2.price > 0 || item2.name == "Shape Of Kitchen") {
            worksheet.unMergeCells(`A${currentRowIndex}:R${currentRowIndex}`);
            worksheet.getCell(`A${currentRowIndex}`).value = `${item2.name} ${item2.label2 ? `(${item2.label2})` : ""}`;
            worksheet.getCell(`E${currentRowIndex}`).value = item2.width || null;
            worksheet.getCell(`G${currentRowIndex}`).value = item2.height || null;
            worksheet.getCell(`I${currentRowIndex}`).value = item2.area || null;
            worksheet.getCell(`C${currentRowIndex}`).value = item2.label;
            worksheet.getCell(`K${currentRowIndex}`).value = item2.qnty || null;
            worksheet.getCell(`M${currentRowIndex}`).value = '';
            worksheet.getCell(`O${currentRowIndex}`).value = item2.rft !=='' || item2.width !=='' ||item2.qnty !=='' || item2.height !=='' || item2.area !==''  && item2.price > 0 ? item2.price : '';
            worksheet.getCell(`Q${currentRowIndex}`).value = item2.remark;

            worksheet.mergeCells(`A${currentRowIndex}:B${currentRowIndex}`);
            worksheet.mergeCells(`C${currentRowIndex}:D${currentRowIndex}`);
            worksheet.mergeCells(`E${currentRowIndex}:F${currentRowIndex}`);
            worksheet.mergeCells(`G${currentRowIndex}:H${currentRowIndex}`);
            worksheet.mergeCells(`I${currentRowIndex}:J${currentRowIndex}`);
            worksheet.mergeCells(`K${currentRowIndex}:L${currentRowIndex}`);
            worksheet.mergeCells(`M${currentRowIndex}:N${currentRowIndex}`);
            worksheet.mergeCells(`O${currentRowIndex}:P${currentRowIndex}`);
            worksheet.mergeCells(`Q${currentRowIndex}:Z${currentRowIndex}`);

            worksheet.getRow(currentRowIndex).height = 35;
            worksheet.getRow(currentRowIndex).eachCell((cell, colIndex) => {
              cell.alignment = { vertical: "middle", horizontal: "centerContinuous", wrapText: true };
            });
            worksheet.getCell(`Q${currentRowIndex}:Z${currentRowIndex}`).alignment = {
              vertical: "middle",
              horizontal: "left", // Set to "left" for this specific merged cell range
              wrapText: true,
            };
            worksheet.getCell(`A${currentRowIndex}:B${currentRowIndex}`).alignment = {
              vertical: "middle",
              horizontal: "left", // Set to "left" for this specific merged cell range
              wrapText: true,
            };
            currentRowIndex++;
          }
          else if (item2.price > 0) {
            worksheet.unMergeCells(`A${currentRowIndex}:R${currentRowIndex}`);
            worksheet.getCell(`A${currentRowIndex}`).value = `${item2.name} ${item2.label2 ? `(${item2.label2})` : ""}`;
            worksheet.getCell(`E${currentRowIndex}`).value = item2.width || null;
            worksheet.getCell(`G${currentRowIndex}`).value = item2.height || null;
            worksheet.getCell(`I${currentRowIndex}`).value = item2.area || null;
            worksheet.getCell(`C${currentRowIndex}`).value = item2.label;
            worksheet.getCell(`K${currentRowIndex}`).value = item2.qnty || null;
            worksheet.getCell(`M${currentRowIndex}`).value = '';
            worksheet.getCell(`O${currentRowIndex}`).value = item2.rft !=='' || item2.width !=='' || item2.qnty !=='' || item2.height !=='' || item2.area !==''  && item2.price > 0 ? item2.price : '';
            worksheet.getCell(`Q${currentRowIndex}`).value = item2.remark;

            worksheet.mergeCells(`A${currentRowIndex}:B${currentRowIndex}`);
            worksheet.mergeCells(`C${currentRowIndex}:D${currentRowIndex}`);
            worksheet.mergeCells(`E${currentRowIndex}:F${currentRowIndex}`);
            worksheet.mergeCells(`G${currentRowIndex}:H${currentRowIndex}`);
            worksheet.mergeCells(`I${currentRowIndex}:J${currentRowIndex}`);
            worksheet.mergeCells(`K${currentRowIndex}:L${currentRowIndex}`);
            worksheet.mergeCells(`M${currentRowIndex}:N${currentRowIndex}`);
            worksheet.mergeCells(`O${currentRowIndex}:P${currentRowIndex}`);
            worksheet.mergeCells(`Q${currentRowIndex}:Z${currentRowIndex}`);

            worksheet.getRow(currentRowIndex).height = 35;
            worksheet.getRow(currentRowIndex).eachCell((cell, colIndex) => {
              cell.alignment = { vertical: "middle", horizontal: "centerContinuous", wrapText: true };
            });
            worksheet.getCell(`Q${currentRowIndex}:Z${currentRowIndex}`).alignment = {
              vertical: "middle",
              horizontal: "left", // Set to "left" for this specific merged cell range
              wrapText: true,
            };
            worksheet.getCell(`A${currentRowIndex}:B${currentRowIndex}`).alignment = {
              vertical: "middle",
              horizontal: "left", // Set to "left" for this specific merged cell range
              wrapText: true,
            };
            currentRowIndex++;
          }
          else if (item2.value > 0) {
            worksheet.unMergeCells(`A${currentRowIndex}:R${currentRowIndex}`);
            worksheet.getCell(`A${currentRowIndex}`).value = `${item2.name ? item2.name : ''}  ${item2.label2 ? `(${item2.label2})` : ""}`;
            worksheet.getCell(`E${currentRowIndex}`).value = item2.width || null;
            worksheet.getCell(`G${currentRowIndex}`).value = null;
            worksheet.getCell(`I${currentRowIndex}`).value = null;
            worksheet.getCell(`C${currentRowIndex}`).value = item2.label;
            worksheet.getCell(`K${currentRowIndex}`).value = item2.qnty || null;
            worksheet.getCell(`M${currentRowIndex}`).value = null;
            worksheet.getCell(`O${currentRowIndex}`).value = item2.rft !=='' || item2.width !==''  || item2.qnty !==''  && item2.value > 0 ? item2.value : '';
            worksheet.getCell(`Q${currentRowIndex}`).value = item2.remark;

            worksheet.mergeCells(`A${currentRowIndex}:B${currentRowIndex}`);
            worksheet.mergeCells(`C${currentRowIndex}:D${currentRowIndex}`);
            worksheet.mergeCells(`E${currentRowIndex}:F${currentRowIndex}`);
            worksheet.mergeCells(`G${currentRowIndex}:H${currentRowIndex}`);
            worksheet.mergeCells(`I${currentRowIndex}:J${currentRowIndex}`);
            worksheet.mergeCells(`K${currentRowIndex}:L${currentRowIndex}`);
            worksheet.mergeCells(`M${currentRowIndex}:N${currentRowIndex}`);
            worksheet.mergeCells(`O${currentRowIndex}:P${currentRowIndex}`);
            worksheet.mergeCells(`Q${currentRowIndex}:Z${currentRowIndex}`);

            worksheet.getRow(currentRowIndex).height = 35;
            worksheet.getRow(currentRowIndex).eachCell((cell, colIndex) => {
              cell.alignment = { vertical: "middle", horizontal: "centerContinuous", wrapText: true };
            });
            worksheet.getCell(`Q${currentRowIndex}:Z${currentRowIndex}`).alignment = {
              vertical: "middle",
              horizontal: "left", // Set to "left" for this specific merged cell range
              wrapText: true,
            };
            worksheet.getCell(`A${currentRowIndex}:B${currentRowIndex}`).alignment = {
              vertical: "middle",
              horizontal: "left", // Set to "left" for this specific merged cell range
              wrapText: true,
            };
            currentRowIndex++;
          }

        }
        );
      });

      // After processing all items, place the GROSS TOTAL in the next available row
      // Get the next available row for "GROSS TOTAL"
      const grossTotalRowIndex = currentRowIndex + 1;
      // Get the next available row for "Sub Total"
      const grossTotalRowIndex2 = grossTotalRowIndex + 1;
      const woodwork = grossTotalRowIndex2 + 1;
      const woodwork2 = woodwork + 1;
      // Get the next available row for "Discount  Total"
      const grossTotalRowIndex3 = woodwork2 + 1;
      // Get the next available row for "GST Total"
      const grossTotalRowIndex4 = grossTotalRowIndex3 + 1;
      // Get the next available row for "Grand Total"
      const grossTotalRowIndex5 = grossTotalRowIndex4 + 1;

      // Insert "GROSS TOTAL" in the appropriate row
      worksheet.getCell(`A${grossTotalRowIndex}`).value = "GROSS TOTAL";
      worksheet.mergeCells(`A${grossTotalRowIndex}:Z${grossTotalRowIndex}`);
      worksheet.getCell(`A${grossTotalRowIndex}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      worksheet.getCell(`A${grossTotalRowIndex}`).font = { bold: true };
      worksheet.getRow(grossTotalRowIndex).height = 30;
      worksheet.getCell(`A${grossTotalRowIndex}`).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "B6D7A8" }, // Light green
      };

      // Insert "Sub Total" in the next available row
      worksheet.getCell(`A${grossTotalRowIndex2}`).value = "Sub Total";
      worksheet.mergeCells(`A${grossTotalRowIndex2}:H${grossTotalRowIndex2}`);
      worksheet.getCell(`A${grossTotalRowIndex2}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex2).height = 20;

      // Insert the Sub Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`I${grossTotalRowIndex2}`).value = `INR ${e.quotationPrice}`;
      worksheet.mergeCells(`I${grossTotalRowIndex2}:R${grossTotalRowIndex2}`);
      worksheet.getCell(`I${grossTotalRowIndex2}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex2).height = 20;

      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // Insert "Sub Total" in the next available row
      worksheet.getCell(`A${woodwork}`).value = "Wood Work";
      worksheet.mergeCells(`A${woodwork}:H${woodwork}`);
      worksheet.getCell(`A${woodwork}`).alignment = { vertical: "middle", horizontal: 'right', wrapText: true };
      worksheet.getRow(woodwork).height = 20;

      // Insert the Sub Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`I${woodwork}`).value = `INR ${e.quotationWood}`;
      worksheet.mergeCells(`I${woodwork}:R${woodwork}`);
      worksheet.getCell(`I${woodwork}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(woodwork).height = 20;

     ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // Insert "Sub Total" in the next available row
      worksheet.getCell(`A${woodwork2}`).value = `Discount (${e.quotationDiscount}%)discount provided on all woodworks`;
      worksheet.mergeCells(`A${woodwork2}:H${woodwork2}`);
      worksheet.getCell(`A${woodwork2}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(woodwork2).height = 20;

      // Insert the Sub Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`I${woodwork2}`).value = `INR ${Math.round(e.quotationWood * (e.quotationDiscount / 100))}`;
      worksheet.mergeCells(`I${woodwork2}:R${woodwork2}`);
      worksheet.getCell(`I${woodwork2}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(woodwork2).height = 20;

      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      
      // Insert "Discount  Total" in the next available row
      worksheet.getCell(`A${grossTotalRowIndex3}`).value = "Discounted Price (exc GST)";
      worksheet.mergeCells(`A${grossTotalRowIndex3}:H${grossTotalRowIndex3}`);
      worksheet.getCell(`A${grossTotalRowIndex3}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex3).height = 20;
      
      // Insert the Discount  Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`I${grossTotalRowIndex3}`).value = `INR ${Math.round((e.quotationPrice - (e.quotationWood * (e.quotationDiscount / 100))))}`;
      worksheet.mergeCells(`I${grossTotalRowIndex3}:R${grossTotalRowIndex3}`);
      worksheet.getCell(`I${grossTotalRowIndex3}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex3).height = 20;

      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      
      // Insert "GST Total" in the next available row
      worksheet.getCell(`A${grossTotalRowIndex4}`).value = "GST";
      worksheet.mergeCells(`A${grossTotalRowIndex4}:H${grossTotalRowIndex4}`);
      worksheet.getCell(`A${grossTotalRowIndex4}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex4).height = 20;

      // Insert the GST Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`I${grossTotalRowIndex4}`).value = `INR ${Math.round((e.quotationPrice - (e.quotationWood * (e.quotationDiscount / 100))) * (e.quotationTaxation || 18)   / 100)}`;
      worksheet.mergeCells(`I${grossTotalRowIndex4}:R${grossTotalRowIndex4}`);
      worksheet.getCell(`I${grossTotalRowIndex4}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex4).height = 20;

      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      
      // Insert "Grand Total (GST) Total" in the next available row
      worksheet.getCell(`A${grossTotalRowIndex5}`).value = "Grand Total (GST)";
      worksheet.mergeCells(`A${grossTotalRowIndex5}:H${grossTotalRowIndex5}`);
      worksheet.getCell(`A${grossTotalRowIndex5}`).alignment = { vertical: "middle", horizontal: 'right', wrapText: true };
      worksheet.getRow(grossTotalRowIndex5).height = 20;

      // Insert the Grand Total (GST) Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`I${grossTotalRowIndex5}`).value = `INR ${Math.round((e.quotationPrice - (e.quotationWood * e.quotationDiscount / 100)) + ((e.quotationPrice - (e.quotationWood * (e.quotationDiscount / 100))) * (e.quotationTaxation  || 18) / 100))}`;
      worksheet.mergeCells(`I${grossTotalRowIndex5}:R${grossTotalRowIndex5}`);
      worksheet.getCell(`I${grossTotalRowIndex5}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex5).height = 20;


      //------------------------///-----------------------------------///

      const grossTotalRowIndex6 = grossTotalRowIndex5 + 1;
      const grossTotalRowIndex7 = grossTotalRowIndex6 + 1;
      const grossTotalRowIndex8 = grossTotalRowIndex7 + 1;
      const grossTotalRowIndex9 = grossTotalRowIndex8 + 1;
      const grossTotalRowIndex10 = grossTotalRowIndex9 + 1;



       // Insert "PAYMENT BREAKUP" in the appropriate row
       worksheet.getCell(`A${grossTotalRowIndex6}`).value = "PAYMENT BREAKUP";
       worksheet.mergeCells(`A${grossTotalRowIndex6}:Z${grossTotalRowIndex6}`);
       worksheet.getCell(`A${grossTotalRowIndex6}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
       worksheet.getCell(`A${grossTotalRowIndex6}`).font = { bold: true };
       worksheet.getRow(grossTotalRowIndex6).height = 30;
       worksheet.getCell(`A${grossTotalRowIndex6}`).fill = {
         type: "pattern",
         pattern: "solid",
         fgColor: { argb: "B6D7A8" }, // Light green
       };


             // Insert "Commitment Advance (10%)" in the next available row
      worksheet.getCell(`A${grossTotalRowIndex7}`).value = "Commitment Advance (10%)";
      worksheet.mergeCells(`A${grossTotalRowIndex7}:H${grossTotalRowIndex7}`);
      worksheet.getCell(`A${grossTotalRowIndex7}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex7).height = 20;

      // Insert the Commitment Advance (10%) Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`I${grossTotalRowIndex7}`).value = `INR ${Math.round(((e.quotationPrice - (e.quotationWood * e.quotationDiscount / 100)) + ((e.quotationPrice - (e.quotationWood * (e.quotationDiscount / 100))) * (e.quotationTaxation  || 18) / 100)) * 10 / 100)}`;
      worksheet.mergeCells(`I${grossTotalRowIndex7}:R${grossTotalRowIndex7}`);
      worksheet.getCell(`I${grossTotalRowIndex7}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex7).height = 20;

      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      
      // Insert "Production Advance (40%)" in the next available row
      worksheet.getCell(`A${grossTotalRowIndex8}`).value = "Production Advance (40%)";
      worksheet.mergeCells(`A${grossTotalRowIndex8}:H${grossTotalRowIndex8}`);
      worksheet.getCell(`A${grossTotalRowIndex8}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex8).height = 20;
      
      // Insert the Production Advance (40%)  Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`I${grossTotalRowIndex8}`).value = `INR ${Math.round(((e.quotationPrice - (e.quotationWood * e.quotationDiscount / 100)) + ((e.quotationPrice - (e.quotationWood * (e.quotationDiscount / 100))) * (e.quotationTaxation  || 18) / 100)) * 40 / 100)}`;
      worksheet.mergeCells(`I${grossTotalRowIndex8}:R${grossTotalRowIndex8}`);
      worksheet.getCell(`I${grossTotalRowIndex8}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex8).height = 20;

      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      
      // Insert "Material Delivery (40%)" in the next available row
      worksheet.getCell(`A${grossTotalRowIndex9}`).value = "Material Delivery (40%)";
      worksheet.mergeCells(`A${grossTotalRowIndex9}:H${grossTotalRowIndex9}`);
      worksheet.getCell(`A${grossTotalRowIndex9}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex9).height = 20;

      // Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`I${grossTotalRowIndex9}`).value = `INR ${Math.round(((e.quotationPrice - (e.quotationWood * e.quotationDiscount / 100)) + ((e.quotationPrice - (e.quotationWood * (e.quotationDiscount / 100))) * (e.quotationTaxation  || 18) / 100)) * 40 / 100)}`;
      worksheet.mergeCells(`I${grossTotalRowIndex9}:R${grossTotalRowIndex9}`);
      worksheet.getCell(`I${grossTotalRowIndex9}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex9).height = 20;

      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      
      // Insert "On Handover (10%)" in the next available row
      worksheet.getCell(`A${grossTotalRowIndex10}`).value = "On Handover (10%)";
      worksheet.mergeCells(`A${grossTotalRowIndex10}:H${grossTotalRowIndex10}`);
      worksheet.getCell(`A${grossTotalRowIndex10}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex10).height = 20;

      // Insert the On Handover (10%) Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`I${grossTotalRowIndex10}`).value = `INR ${Math.round(((e.quotationPrice - (e.quotationWood * e.quotationDiscount / 100)) + ((e.quotationPrice - (e.quotationWood * (e.quotationDiscount / 100))) * (e.quotationTaxation  || 18) / 100)) * 10 / 100)}`;
      worksheet.mergeCells(`I${grossTotalRowIndex10}:R${grossTotalRowIndex10}`);
      worksheet.getCell(`I${grossTotalRowIndex10}`).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
      worksheet.getRow(grossTotalRowIndex10).height = 20;


     //------------------------///-----------------------------------///

      const grossTotalRowIndex11 = grossTotalRowIndex10 + 1;
      const grossTotalRowIndex12 = grossTotalRowIndex11 + 1;
      const grossTotalRowIndex13 = grossTotalRowIndex12 + 1;
      const grossTotalRowIndex14 = grossTotalRowIndex13 + 1;
      const grossTotalRowIndex15 = grossTotalRowIndex14 + 1;
      const grossTotalRowIndex16 = grossTotalRowIndex15 + 1;



       // Insert "Material Specifications" in the appropriate row
       worksheet.getCell(`A${grossTotalRowIndex11}`).value = "Material Specifications";
       worksheet.mergeCells(`A${grossTotalRowIndex11}:Z${grossTotalRowIndex11}`);
       worksheet.getCell(`A${grossTotalRowIndex11}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
       worksheet.getCell(`A${grossTotalRowIndex11}`).font = { bold: true };
       worksheet.getRow(grossTotalRowIndex11).height = 30;
       worksheet.getCell(`A${grossTotalRowIndex11}`).fill = {
         type: "pattern",
         pattern: "solid",
         fgColor: { argb: "B6D7A8" }, // Light green
       };


             // Insert "Laminate:" in the next available row
      worksheet.getCell(`A${grossTotalRowIndex12}`).value = "Laminate:";
      worksheet.mergeCells(`A${grossTotalRowIndex12}:E${grossTotalRowIndex12}`);
      worksheet.getCell(`A${grossTotalRowIndex12}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      worksheet.getRow(grossTotalRowIndex12).height = 50;

      // Insert the Commitment Advance (10%) Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`F${grossTotalRowIndex12}`).value = `(Merino, Greenlam, Century, Realtouch, Heritage, Royal Touch). External Matt Laminated Finish 1.0 mm (Any Brand - SF, upto Rs. 1200 per sheet), unless otherwise specified. Internal Matt finish laminate of 0.79-0.8 mm, Hazel Cambric/off white color, unless and otherwise specified.`;
      worksheet.mergeCells(`F${grossTotalRowIndex12}:Z${grossTotalRowIndex12}`);
      worksheet.getCell(`F${grossTotalRowIndex12}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      worksheet.getRow(grossTotalRowIndex12).height = 50;

      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      
      // Insert "Production Advance (40%)" in the next available row
      worksheet.getCell(`A${grossTotalRowIndex13}`).value = "PLY:";
      worksheet.mergeCells(`A${grossTotalRowIndex13}:E${grossTotalRowIndex13}`);
      worksheet.getCell(`A${grossTotalRowIndex13}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      worksheet.getRow(grossTotalRowIndex13).height = 50;
      
      // Insert the Production Advance (40%)  Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`F${grossTotalRowIndex13}`).value = `Choose between Century Sainik & Prelaminated board FABDIZ make from Indiana. Kitchen, Utility and Washroom - Below Boxes in BWP (Water Proof) Ply - 16 mm (Calibrated). Kitchen above boxes, wardrobe, other units, such as crockery/display/loft unit etc. in MR (Moisture Resistant) Ply - 16 mm (Calibrated).`;
      worksheet.mergeCells(`F${grossTotalRowIndex13}:Z${grossTotalRowIndex13}`);
      worksheet.getCell(`F${grossTotalRowIndex13}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      worksheet.getRow(grossTotalRowIndex13).height =50;

      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      
      // Insert "Material Delivery (40%)" in the next available row
      worksheet.getCell(`A${grossTotalRowIndex14}`).value = "Hardware:";
      worksheet.mergeCells(`A${grossTotalRowIndex14}:E${grossTotalRowIndex14}`);
      worksheet.getCell(`A${grossTotalRowIndex14}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      worksheet.getRow(grossTotalRowIndex14).height = 80;

      // Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`F${grossTotalRowIndex14}`).value = `Hafele/Hettich/EBCO Hinges and other hardware (Tandem Box, Channels, Sliders etc) shall be of regular operations (Soft Close on Demand). Handles, Knobs, shall be of local supply (with basic rate of Rs. 100/pc 8 inch and Rs, 50/Pc 4 inch) or as per selection . Wire-Baskets (Plate, thanli, cutlery or bottle pullout) if any, shall be stainless steel (Local Supply) grade-304. Wicker Basket if any, will be local supply as per IS standards and size customizable. Kitchen Skirting shall be a PVC make of approved color and finish with PVC adjustable legs. 5mm plain glass for glass shutters, unless otherwise specified with wooden frame. (Aluminium shutters can be on demand). 6mm plain glass for Shelves ad per drawings or unless otherwise specified.( Complimentary :- Handles/Knobs (upto 6 inch) from our selected board. )`;
      worksheet.mergeCells(`F${grossTotalRowIndex14}:Z${grossTotalRowIndex14}`);
      worksheet.getCell(`F${grossTotalRowIndex14}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      worksheet.getRow(grossTotalRowIndex14).height = 80;

      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      
      // Insert "On Handover (10%)" in the next available row
      worksheet.getCell(`A${grossTotalRowIndex15}`).value = "Others:";
      worksheet.mergeCells(`A${grossTotalRowIndex15}:E${grossTotalRowIndex15}`);
      worksheet.getCell(`A${grossTotalRowIndex15}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      worksheet.getRow(grossTotalRowIndex15).height = 60;

      // Insert the On Handover (10%) Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`F${grossTotalRowIndex15}`).value = `SS Shelf pins, Clamps, Screw and other fixtures - local supply. Dowels & Mini-fix - Hettich. Glue - Pedilite (Fevicol), Araldite, Jotun, Rehau, woodmaster or equivelent based on application. Edge Banding - Rehau or Equivalent (1mm or 2mm as per application).`;
      worksheet.mergeCells(`F${grossTotalRowIndex15}:Z${grossTotalRowIndex15}`);
      worksheet.getCell(`F${grossTotalRowIndex15}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      worksheet.getRow(grossTotalRowIndex15).height = 60;

      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      
      // Insert "On Handover (10%)" in the next available row
      worksheet.getCell(`A${grossTotalRowIndex16}`).value = "Paint, Polish & Powdercoat:";
      worksheet.mergeCells(`A${grossTotalRowIndex16}:E${grossTotalRowIndex16}`);
      worksheet.getCell(`A${grossTotalRowIndex16}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      worksheet.getRow(grossTotalRowIndex16).height = 20;

      // Insert the On Handover (10%) Total price (assuming `e.quotationPrice` exists)
      worksheet.getCell(`F${grossTotalRowIndex16}`).value = `As per selection (Asian, Dulux, Berger, RAL), only if mentioned in quote.`;
      worksheet.mergeCells(`F${grossTotalRowIndex16}:Z${grossTotalRowIndex16}`);
      worksheet.getCell(`F${grossTotalRowIndex16}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      worksheet.getRow(grossTotalRowIndex16).height = 20;


//------------------------///-----------------------------------///

const grossTotalRowIndex17 = grossTotalRowIndex16 + 1;
const messed = grossTotalRowIndex17 + 1;
const grossTotalRowIndex18 = messed + 1;
const grossTotalRowIndex19 = grossTotalRowIndex18 + 1;
const grossTotalRowIndex20 = grossTotalRowIndex19 + 1;



 // Insert "Material Specifications" in the appropriate row
 worksheet.getCell(`A${grossTotalRowIndex17}`).value = "TERMS AND CONDITIONS";
 worksheet.mergeCells(`A${grossTotalRowIndex17}:Z${grossTotalRowIndex17}`);
 worksheet.getCell(`A${grossTotalRowIndex17}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
 worksheet.getCell(`A${grossTotalRowIndex17}`).font = { bold: true };
 worksheet.getRow(grossTotalRowIndex17).height = 50;
 worksheet.getCell(`A${grossTotalRowIndex17}`).fill = {
   type: "pattern",
   pattern: "solid",
   fgColor: { argb: "B6D7A8" }, // Light green
 };

 worksheet.getCell(`A${messed}`).value = "Warranty";
 worksheet.mergeCells(`A${messed}:Z${messed}`);
 worksheet.getCell(`A${messed}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
 worksheet.getCell(`A${messed}`).font = { bold: true };
 worksheet.getRow(messed).height = 30;
 worksheet.getCell(`A${messed}`).fill = {
   type: "pattern",
   pattern: "solid",
   fgColor: { argb: "92C3DF" }, // Light green
 };


       // Insert "Laminate:" in the next available row
worksheet.getCell(`A${grossTotalRowIndex18}`).value = "1";
worksheet.mergeCells(`A${grossTotalRowIndex18}:E${grossTotalRowIndex18}`);
worksheet.getCell(`A${grossTotalRowIndex18}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex18).height = 50;

// Insert the Commitment Advance (10%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex18}`).value = `We provide 10 years warranty for plywood, This safeguards you against any defect in manufacturing or in installation workmanship under normal usage. Hardware warranty will be apllicable based on the brands chosen For custom work, there is no warranty applicable. For more information about warranty policy we suggest you to ask FABDIZ warranty policy to our Design consultant.`;
worksheet.mergeCells(`F${grossTotalRowIndex18}:Z${grossTotalRowIndex18}`);
worksheet.getCell(`F${grossTotalRowIndex18}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex18).height = 50;

////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Production Advance (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex19}`).value = "";
worksheet.mergeCells(`A${grossTotalRowIndex19}:E${grossTotalRowIndex19}`);
worksheet.getCell(`A${grossTotalRowIndex19}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex19).height = 30;

// Insert the Production Advance (40%)  Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex19}`).value = `Note : 1 year of free servicing for our product`;
worksheet.mergeCells(`F${grossTotalRowIndex19}:Z${grossTotalRowIndex19}`);
worksheet.getCell(`F${grossTotalRowIndex19}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex19).height = 30;

////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex20}`).value = "2";
worksheet.mergeCells(`A${grossTotalRowIndex20}:E${grossTotalRowIndex20}`);
worksheet.getCell(`A${grossTotalRowIndex20}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex20).height = 30;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex20}`).value = `All accessories, hardware and appliances are covered as per the respective Manufacturers.`;
worksheet.mergeCells(`F${grossTotalRowIndex20}:Z${grossTotalRowIndex20}`);
worksheet.getCell(`F${grossTotalRowIndex20}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex20).height = 30;


//------------------------///-----------------------------------///

const grossTotalRowIndex21 = grossTotalRowIndex20 + 1;
const grossTotalRowIndex22 = grossTotalRowIndex21 + 1;
const grossTotalRowIndex23 = grossTotalRowIndex22 + 1;
const grossTotalRowIndex24 = grossTotalRowIndex23 + 1;
const grossTotalRowIndex25 = grossTotalRowIndex24 + 1;
const grossTotalRowIndex26 = grossTotalRowIndex25 + 1;
const grossTotalRowIndex27 = grossTotalRowIndex26 + 1;
const grossTotalRowIndex28 = grossTotalRowIndex27 + 1;
const grossTotalRowIndex29 = grossTotalRowIndex28 + 1;
const grossTotalRowIndex30 = grossTotalRowIndex29 + 1;
const grossTotalRowIndex31 = grossTotalRowIndex30 + 1;
const grossTotalRowIndex32 = grossTotalRowIndex31 + 1;
const grossTotalRowIndex33 = grossTotalRowIndex32 + 1;
const grossTotalRowIndex34 = grossTotalRowIndex33 + 1;
const grossTotalRowIndex35 = grossTotalRowIndex34 + 1;
const grossTotalRowIndex36 = grossTotalRowIndex35 + 1;
const grossTotalRowIndex37 = grossTotalRowIndex36 + 1;
const grossTotalRowIndex38 = grossTotalRowIndex37 + 1;



 // Insert "Material Specifications" in the appropriate row
 worksheet.getCell(`A${grossTotalRowIndex21}`).value = "General terms";
 worksheet.mergeCells(`A${grossTotalRowIndex21}:Z${grossTotalRowIndex21}`);
 worksheet.getCell(`A${grossTotalRowIndex21}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
 worksheet.getCell(`A${grossTotalRowIndex21}`).font = { bold: true };
 worksheet.getRow(grossTotalRowIndex21).height = 30;
 worksheet.getCell(`A${grossTotalRowIndex21}`).fill = {
   type: "pattern",
   pattern: "solid",
   fgColor: { argb: "92C3DF" }, // Light green
 };


       // Insert "Laminate:" in the next available row
worksheet.getCell(`A${grossTotalRowIndex22}`).value = "1";
worksheet.mergeCells(`A${grossTotalRowIndex22}:E${grossTotalRowIndex22}`);
worksheet.getCell(`A${grossTotalRowIndex22}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex22).height = 50;

// Insert the Commitment Advance (10%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex22}`).value = `Chimney, Sink, Hob, Gas Piping, Granite along with the labour cost associated are not included in this quotation unless mentioned otherwise.`;
worksheet.mergeCells(`F${grossTotalRowIndex22}:Z${grossTotalRowIndex22}`);
worksheet.getCell(`F${grossTotalRowIndex22}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex22).height = 50;

////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Production Advance (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex23}`).value = "2";
worksheet.mergeCells(`A${grossTotalRowIndex23}:E${grossTotalRowIndex23}`);
worksheet.getCell(`A${grossTotalRowIndex23}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex23).height = 50;

// Insert the Production Advance (40%)  Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex23}`).value = `Light Fittings, Geyser, Bathroom Fittings, Fans and any other electrical fittings are not included in this quotation unless mentioned otherwise.`;
worksheet.mergeCells(`F${grossTotalRowIndex23}:Z${grossTotalRowIndex23}`);
worksheet.getCell(`F${grossTotalRowIndex23}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex23).height = 50;

////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex24}`).value = "3";
worksheet.mergeCells(`A${grossTotalRowIndex24}:E${grossTotalRowIndex24}`);
worksheet.getCell(`A${grossTotalRowIndex24}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex24).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex24}`).value = `Any product that is not added in this Quotation has to be assumed as Non Tendered Product, a revised quote will be provided for the same. FABDIZ will only be responsible for work mentioned in the quotation.`;
worksheet.mergeCells(`F${grossTotalRowIndex24}:Z${grossTotalRowIndex24}`);
worksheet.getCell(`F${grossTotalRowIndex24}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex24).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex25}`).value = "4";
worksheet.mergeCells(`A${grossTotalRowIndex25}:E${grossTotalRowIndex25}`);
worksheet.getCell(`A${grossTotalRowIndex25}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex25).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex25}`).value = `Alteration of the existing electrical wiring/points and plumbing wiring/points will be charged extra and for any civil changes like plumbing and wall chipping we need civil engineers for instructions.`;
worksheet.mergeCells(`F${grossTotalRowIndex25}:Z${grossTotalRowIndex25}`);
worksheet.getCell(`F${grossTotalRowIndex25}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex25).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex26}`).value = "5";
worksheet.mergeCells(`A${grossTotalRowIndex26}:E${grossTotalRowIndex26}`);
worksheet.getCell(`A${grossTotalRowIndex26}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex26).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex26}`).value = `FABDIZ execution team takes the responsibility of moving debris to Garbage Room of the apartment premises.`;
worksheet.mergeCells(`F${grossTotalRowIndex26}:Z${grossTotalRowIndex26}`);
worksheet.getCell(`F${grossTotalRowIndex26}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex26).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex27}`).value = "6";
worksheet.mergeCells(`A${grossTotalRowIndex27}:E${grossTotalRowIndex27}`);
worksheet.getCell(`A${grossTotalRowIndex27}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex27).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex27}`).value = `FABDIZ execution team takes the responsibility of cleaning floor & interiors before moving out of the site (Deep cleaning not included).`;
worksheet.mergeCells(`F${grossTotalRowIndex27}:Z${grossTotalRowIndex27}`);
worksheet.getCell(`F${grossTotalRowIndex27}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex27).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex28}`).value = "7";
worksheet.mergeCells(`A${grossTotalRowIndex28}:E${grossTotalRowIndex28}`);
worksheet.getCell(`A${grossTotalRowIndex28}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex28).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex28}`).value = `Sliding Door Track fitting will bring 15-25mm gap between the Sliding Door and loft. As we need that gap during the maintenance. Sliding Door Track fitting will bring 10mm gap between the door overlapping.`;
worksheet.mergeCells(`F${grossTotalRowIndex28}:Z${grossTotalRowIndex28}`);
worksheet.getCell(`F${grossTotalRowIndex28}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex28).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex29}`).value = "8";
worksheet.mergeCells(`A${grossTotalRowIndex29}:E${grossTotalRowIndex29}`);
worksheet.getCell(`A${grossTotalRowIndex29}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex29).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex29}`).value = `Product with glossy finish may have very less unevenness look and feel due to lighting effect.`;
worksheet.mergeCells(`F${grossTotalRowIndex29}:Z${grossTotalRowIndex29}`);
worksheet.getCell(`F${grossTotalRowIndex29}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex29).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex30}`).value = "9";
worksheet.mergeCells(`A${grossTotalRowIndex30}:E${grossTotalRowIndex30}`);
worksheet.getCell(`A${grossTotalRowIndex30}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex30).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex30}`).value = `This quotation will be valid for 1 month.`;
worksheet.mergeCells(`F${grossTotalRowIndex30}:Z${grossTotalRowIndex30}`);
worksheet.getCell(`F${grossTotalRowIndex30}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex30).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex31}`).value = "10";
worksheet.mergeCells(`A${grossTotalRowIndex31}:E${grossTotalRowIndex31}`);
worksheet.getCell(`A${grossTotalRowIndex31}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex31).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex31}`).value = `Final coat of paint should be done after completion of interior work from client side We are unable to avoid handmarks, scratches during installation.`;
worksheet.mergeCells(`F${grossTotalRowIndex31}:Z${grossTotalRowIndex31}`);
worksheet.getCell(`F${grossTotalRowIndex31}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex31).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex32}`).value = "11";
worksheet.mergeCells(`A${grossTotalRowIndex32}:E${grossTotalRowIndex32}`);
worksheet.getCell(`A${grossTotalRowIndex32}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex32).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex32}`).value = `There will be difference between in handmade furniture and modular furniture. As handmade furniture by carpenters on site with hand tools so as compared to modular work handmade furniture finishing will differ.`;
worksheet.mergeCells(`F${grossTotalRowIndex32}:Z${grossTotalRowIndex32}`);
worksheet.getCell(`F${grossTotalRowIndex32}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex32).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex33}`).value = "12";
worksheet.mergeCells(`A${grossTotalRowIndex33}:E${grossTotalRowIndex33}`);
worksheet.getCell(`A${grossTotalRowIndex33}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex33).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex33}`).value = `Images shown in the 3d are for reference, please refer actual samples for colour selection and texture / wallpapers or any decor items which might be shown only for reference.`;
worksheet.mergeCells(`F${grossTotalRowIndex33}:Z${grossTotalRowIndex33}`);
worksheet.getCell(`F${grossTotalRowIndex33}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex33).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex34}`).value = "13";
worksheet.mergeCells(`A${grossTotalRowIndex34}:E${grossTotalRowIndex34}`);
worksheet.getCell(`A${grossTotalRowIndex34}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex34).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex34}`).value = `Design alterations will not be considered once the design document is signed off or once FADBIZ get confirmation for design document through mail/electronic media`;
worksheet.mergeCells(`F${grossTotalRowIndex34}:Z${grossTotalRowIndex34}`);
worksheet.getCell(`F${grossTotalRowIndex34}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex34).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex35}`).value = "14";
worksheet.mergeCells(`A${grossTotalRowIndex35}:E${grossTotalRowIndex35}`);
worksheet.getCell(`A${grossTotalRowIndex35}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex35).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex35}`).value = `Production date will start as per the schedule that will be shar`;
worksheet.mergeCells(`F${grossTotalRowIndex35}:Z${grossTotalRowIndex35}`);
worksheet.getCell(`F${grossTotalRowIndex35}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex35).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex36}`).value = "15";
worksheet.mergeCells(`A${grossTotalRowIndex36}:E${grossTotalRowIndex36}`);
worksheet.getCell(`A${grossTotalRowIndex36}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex36).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex36}`).value = `Any modifications at site should be informed to the designer and project manager prior to production.`;
worksheet.mergeCells(`F${grossTotalRowIndex36}:Z${grossTotalRowIndex36}`);
worksheet.getCell(`F${grossTotalRowIndex36}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex36).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex37}`).value = "16";
worksheet.mergeCells(`A${grossTotalRowIndex37}:E${grossTotalRowIndex37}`);
worksheet.getCell(`A${grossTotalRowIndex37}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex37).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex37}`).value = `FABDIZ will not be responsible for products purchased from elsewhere.`;
worksheet.mergeCells(`F${grossTotalRowIndex37}:Z${grossTotalRowIndex37}`);
worksheet.getCell(`F${grossTotalRowIndex37}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex37).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex38}`).value = "17";
worksheet.mergeCells(`A${grossTotalRowIndex38}:E${grossTotalRowIndex38}`);
worksheet.getCell(`A${grossTotalRowIndex38}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex38).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex38}`).value = `The Entertainment Cabinet and other modular cabinets more than 2400MM will be having two cabinets in that case the joint at the top of the cabinet will be visible.`;
worksheet.mergeCells(`F${grossTotalRowIndex38}:Z${grossTotalRowIndex38}`);
worksheet.getCell(`F${grossTotalRowIndex38}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex38).height = 50;



const grossTotalRowIndex39 = grossTotalRowIndex38 + 1;
const grossTotalRowIndex40 = grossTotalRowIndex39 + 1;
const grossTotalRowIndex41 = grossTotalRowIndex40 + 1;
const grossTotalRowIndex42 = grossTotalRowIndex41 + 1;
const grossTotalRowIndex43 = grossTotalRowIndex42 + 1;
const grossTotalRowIndex44 = grossTotalRowIndex43 + 1;



 // Insert "Material Specifications" in the appropriate row
 worksheet.getCell(`A${grossTotalRowIndex39}`).value = "Design Process";
 worksheet.mergeCells(`A${grossTotalRowIndex39}:Z${grossTotalRowIndex39}`);
 worksheet.getCell(`A${grossTotalRowIndex39}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
 worksheet.getCell(`A${grossTotalRowIndex39}`).font = { bold: true };
 worksheet.getRow(grossTotalRowIndex39).height = 30;
 worksheet.getCell(`A${grossTotalRowIndex39}`).fill = {
   type: "pattern",
   pattern: "solid",
   fgColor: { argb: "92C3DF" }, // Light green
 };


       // Insert "Laminate:" in the next available row
worksheet.getCell(`A${grossTotalRowIndex40}`).value = "1";
worksheet.mergeCells(`A${grossTotalRowIndex40}:E${grossTotalRowIndex40}`);
worksheet.getCell(`A${grossTotalRowIndex40}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex40).height = 50;

// Insert the Commitment Advance (10%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex40}`).value = `Site Visit : Once booking advance paid Interior Designer will visit the client site with measurement team.`;
worksheet.mergeCells(`F${grossTotalRowIndex40}:Z${grossTotalRowIndex40}`);
worksheet.getCell(`F${grossTotalRowIndex40}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex40).height = 50;

////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Production Advance (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex41}`).value = "2";
worksheet.mergeCells(`A${grossTotalRowIndex41}:E${grossTotalRowIndex41}`);
worksheet.getCell(`A${grossTotalRowIndex41}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex41).height = 50;

// Insert the Production Advance (40%)  Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex41}`).value = `Discussion Meeting: Designer will show the modular library, completed project photographs which will match to client requirement.`;
worksheet.mergeCells(`F${grossTotalRowIndex41}:Z${grossTotalRowIndex41}`);
worksheet.getCell(`F${grossTotalRowIndex41}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex41).height = 50;

////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex42}`).value = "3";
worksheet.mergeCells(`A${grossTotalRowIndex42}:E${grossTotalRowIndex42}`);
worksheet.getCell(`A${grossTotalRowIndex42}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex42).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex42}`).value = `Modeling Presentation: As per client requirement and placement of furniture designer will present modeling. (upto 2 iteration can be done in the 3d model stage post that timelines may change as per additional design changes.`;
worksheet.mergeCells(`F${grossTotalRowIndex42}:Z${grossTotalRowIndex42}`);
worksheet.getCell(`F${grossTotalRowIndex42}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex42).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex43}`).value = "4";
worksheet.mergeCells(`A${grossTotalRowIndex43}:E${grossTotalRowIndex43}`);
worksheet.getCell(`A${grossTotalRowIndex43}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex43).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex43}`).value = `3D Design Presentation: will present 3D design which will have the texture selected by client.`;
worksheet.mergeCells(`F${grossTotalRowIndex43}:Z${grossTotalRowIndex43}`);
worksheet.getCell(`F${grossTotalRowIndex43}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex43).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex44}`).value = "5";
worksheet.mergeCells(`A${grossTotalRowIndex44}:E${grossTotalRowIndex44}`);
worksheet.getCell(`A${grossTotalRowIndex44}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex44).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex44}`).value = `Site Validation: Validation will be done at site where FABDIZ will execute project. Designer will visit the site with Project Manager for Masking Measurement. Masking measurement will be possible only on cleaned floor.`;
worksheet.mergeCells(`F${grossTotalRowIndex44}:Z${grossTotalRowIndex44}`);
worksheet.getCell(`F${grossTotalRowIndex44}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex44).height = 50;


const grossTotalRowIndex45 = grossTotalRowIndex44 + 1;
const grossTotalRowIndex46 = grossTotalRowIndex45 + 1;
const grossTotalRowIndex47 = grossTotalRowIndex46 + 1;
const grossTotalRowIndex48 = grossTotalRowIndex47 + 1;
const grossTotalRowIndex49 = grossTotalRowIndex48 + 1;



 // Insert "Material Specifications" in the appropriate row
 worksheet.getCell(`A${grossTotalRowIndex45}`).value = "Payment Process ( Final design quote to be considered ):";
 worksheet.mergeCells(`A${grossTotalRowIndex45}:Z${grossTotalRowIndex45}`);
 worksheet.getCell(`A${grossTotalRowIndex45}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
 worksheet.getCell(`A${grossTotalRowIndex45}`).font = { bold: true };
 worksheet.getRow(grossTotalRowIndex45).height = 30;
 worksheet.getCell(`A${grossTotalRowIndex45}`).fill = {
   type: "pattern",
   pattern: "solid",
   fgColor: { argb: "92C3DF" }, // Light green
 };


       // Insert "Laminate:" in the next available row
worksheet.getCell(`A${grossTotalRowIndex46}`).value = "1";
worksheet.mergeCells(`A${grossTotalRowIndex46}:E${grossTotalRowIndex46}`);
worksheet.getCell(`A${grossTotalRowIndex46}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex46).height = 50;

// Insert the Commitment Advance (10%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex46}`).value = `10% appointment investment as a designer (Part of final quote).`;
worksheet.mergeCells(`F${grossTotalRowIndex46}:Z${grossTotalRowIndex46}`);
worksheet.getCell(`F${grossTotalRowIndex46}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex46).height = 50;

////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Production Advance (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex47}`).value = "2";
worksheet.mergeCells(`A${grossTotalRowIndex47}:E${grossTotalRowIndex47}`);
worksheet.getCell(`A${grossTotalRowIndex47}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex47).height = 50;

// Insert the Production Advance (40%)  Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex47}`).value = `40% of final design quote value, upon design sign off to start production.`;
worksheet.mergeCells(`F${grossTotalRowIndex47}:Z${grossTotalRowIndex47}`);
worksheet.getCell(`F${grossTotalRowIndex47}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex47).height = 50;

////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Insert "Material Delivery (40%)" in the next available row
worksheet.getCell(`A${grossTotalRowIndex48}`).value = "3";
worksheet.mergeCells(`A${grossTotalRowIndex48}:E${grossTotalRowIndex48}`);
worksheet.getCell(`A${grossTotalRowIndex48}`).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
worksheet.getRow(grossTotalRowIndex48).height = 50;

// Insert the Material Delivery (40%) Total price (assuming `e.quotationPrice` exists)
worksheet.getCell(`F${grossTotalRowIndex48}`).value = `40% before the dispach of the material is done at site`;
worksheet.mergeCells(`F${grossTotalRowIndex48}:Z${grossTotalRowIndex48}`);
worksheet.getCell(`F${grossTotalRowIndex48}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex48).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// 4
worksheet.getCell(`A${grossTotalRowIndex49}`).value = "4";
worksheet.mergeCells(`A${grossTotalRowIndex49}:E${grossTotalRowIndex49}`);
worksheet.getCell(`A${grossTotalRowIndex49}`).alignment = { vertical: "middle", horizontal: 'center', wrapText: true };
worksheet.getRow(grossTotalRowIndex49).height = 50;

// 10% - PDC to be given after 90% of work done at site
worksheet.getCell(`F${grossTotalRowIndex49}`).value = `10% - PDC to be given after 90% of work done at site`;
worksheet.mergeCells(`F${grossTotalRowIndex49}:Z${grossTotalRowIndex49}`);
worksheet.getCell(`F${grossTotalRowIndex49}`).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
worksheet.getRow(grossTotalRowIndex49).height = 50;
////////////////////////////////////////////////////////////////////////////////////////////////////////////////




      // Save the workbook
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), "ExportedFile.xlsx");
      setLoader(false);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
    }
  };

  return (
    <div>
    <button className="buttonDesign" onClick={exportToExcel} disabled={loader}>
      {loader ? (
        <span>
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Exporting...
        </span>
      ) : (
        "Export to Excel"
      )}
    </button>
  </div>
  );
}
